<template>
  <input type="hidden" name="authenticity_token" :value="csrfToken" />
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import getCsrfToken from 'bits/csrf_token'

export default {
  data: function () {
    return {
      csrfToken: null,
    }
  },
  mounted() {
    this.csrfToken = getCsrfToken()
  },
}
</script>
